module.exports = __webpack_public_path__ + "img/home-07-cosmo-03-coc-02.7d6d129f.jpg";